import App from "../../App";
import Forms from "../Forms/Forms";

const DragAndDrop = {

    animationCircleColors: ['red', 'green', 'blue'],
    animationCircleSizes: ['size01', 'size02', 'size03'],

    allowedExtensions: [],
    importForCompany: null,
    importType: null,

    init(el) {

        this.el = $('.dropZone');

        if (!this.el.length) {
            return;
        }

        this.dropZone = this.el;//.find('.dropZone');

        this.dragDrop = this.el.find('[component="DragAndDrop"]');
        this.fileInput = this.dragDrop.find('.file-input');
        this.fileList = this.dragDrop.find('.file-list');
        this.selectButton = this.dragDrop.find('.select-button');
        this.circleIndicator = this.dragDrop.find('.ball');
        this.previewTemplate = this.dragDrop.find('template[element="filePreview"]').html();
        this.selectInputs = this.dragDrop.find('select');
        this.companySelector = this.dragDrop.find('.companySelectorInput');

        this.start();
        this.bind();
    },

    start() {
        this.dragDrop.appendTo('[component="Layout"]');

        this.setAllowedExtensions();
        this.setImportForCompany();
        this.setImportType();
    },

    bind() {

        let dragmove = 0;

        this.dragDrop.on("click", function (e) {
            if ($(e.target).is('[component="DragAndDrop"]')) {
                DragAndDrop.hide();
                DragAndDrop.clearFilePreviewList();
            }
        });

        this.selectButton.on("click", function (e) {
            DragAndDrop.fileInput.trigger("click");
        });

        this.selectInputs.on("change", function (e) {
            e.preventDefault();

            DragAndDrop.setImportForCompany();
            DragAndDrop.clearFilePreviewList();
            //return false;
        });

        // Prevent the default behavior when files are dragged over the drop zone
        this.dropZone.on("dragover", function (e) {
            e.preventDefault();

            clearTimeout(dragmove);

            if (!DragAndDrop.containsFiles(e.originalEvent)) {
                return;
            }

            if ($(DragAndDrop.selectButton).is(":animated")) {
                return;
            }

            if (DragAndDrop.fileList.children().length !== 0) {
                DragAndDrop.fileList.html("");
            }

            $(DragAndDrop.dragDrop).removeClass("hidden");

            if ($(DragAndDrop.dragDrop).is(".highlight")) {
                return false;
            }

            dragmove = setTimeout(() => {
                $(DragAndDrop.dragDrop).addClass("highlight");

                DragAndDrop.setAnimationBalls();
            }, 1);
        });

        // Remove the highlight when the drag operation ends
        this.dragDrop.on("dragleave", function () {
            clearTimeout(dragmove);

            if ($(DragAndDrop.selectButton).is(":animated")) {
                console.log("animated");
                return;
            }
            //if( $(this).is(DragAndDrop.el))
            dragmove = setTimeout(() => {
                $(DragAndDrop.dragDrop).removeClass("highlight");//.addClass("hidden");
            }, 500);
        });

        // Handle file drop
        this.dropZone.on("drop", function (e) {
            e.preventDefault();

            if (!DragAndDrop.containsFiles(e.originalEvent)) {
                return;
            }

            $(DragAndDrop.dragDrop).removeClass("highlight");

            const files = e.originalEvent.dataTransfer.files;
            let delay = 0;

            if (files.length === 1) {
                let companyID;

                if (companyID = DragAndDrop.getCompanyIDFromFilename(files[0])) {

                    DragAndDrop.setCompanyFromFilename(companyID);
                    delay = 250;
                }
            }

            if (ALLOW_DRAGDROP === true) {
                setTimeout(() => {
                    DragAndDrop.handleFiles(files);
                }, delay);
            }
        });

        // Handle file selection from the file input
        this.fileInput.on("change", function () {
            const files = DragAndDrop.fileInput[0].files;
            let companyID;

            if (companyID = DragAndDrop.getCompanyIDFromFilename(files[0])) {

                DragAndDrop.setCompanyFromFilename(companyID);
            }

            DragAndDrop.handleFiles(files);
        });
    },

    setAllowedExtensions() {
        let allowedFileTypes = this.dragDrop.data("allowfiletype");

        if (!allowedFileTypes) {
            console.warn('Missing allowed file type specification');
            return;
        }

        DragAndDrop.allowedExtensions = allowedFileTypes;
    },

    setImportForCompany() {
        let companyID = this.companySelector.val();

        if (!companyID) {
            console.warn('Missing assigned company ID for import');
            return;
        }

        DragAndDrop.importForCompany = companyID;
    },

    setCompanyFromFilename(companyID) {
        if (!this.companySelector) {
            console.warn('Missing company selector element for imports');
            return;
        }

        console.warn("Changed value in company selector element with id from imported filename");
        DragAndDrop.companySelector.val(companyID);
        DragAndDrop.setImportForCompany();
    },

    getCompanyIDFromFilename(file) {
        if (typeof DRAGDROP_FILE_VARIATIONS === 'undefined') {
            console.warn('Missing filename variations for each company.');
            return;
        }

        if (!App.isJson(DRAGDROP_FILE_VARIATIONS)) {
            console.warn('Variable „DRAGDROP_FILE_VARIATIONS“ is not valid json.');
            return;
        }

        let variations = JSON.parse(DRAGDROP_FILE_VARIATIONS);
        let filename = file.name.toLowerCase();
        let companyID = null;

        Object.keys(variations).forEach(function (key, index) {
            if (variations[key].some(value => filename.includes(value))) {
                companyID = key;
            }
        });

        return companyID;
    },

    setImportType() {
        if (typeof IMPORT_TYPE === 'undefined') {
            console.warn('Missing import type.');
            return;
        }

        this.importType = IMPORT_TYPE;
    },

    show() {
        this.dragDrop.removeClass("hidden");
    },

    hide() {
        this.dragDrop.addClass("hidden");
    },

    disableButton() {
        DragAndDrop.selectButton.attr("disabled", true);
    },

    allowButton() {
        DragAndDrop.selectButton.removeAttr("disabled", false);
    },

    clearFilePreviewList() {
        DragAndDrop.fileList.addClass("clearing");

        setTimeout(() => {
            DragAndDrop.resetFilePreviewList();
        }, 2000);
    },

    resetFilePreviewList() {
        DragAndDrop.fileList.html("");
        DragAndDrop.fileList.removeClass("clearing");
    },

    handleFiles(files) {

        let multiCompanyUser = DragAndDrop.selectInputs.children().length > 1;

        DragAndDrop.disableButton();
        DragAndDrop.resetFilePreviewList();

        let i = 0;

        (async function () {
            for (let file of files) {
                i++;

                await DragAndDrop.sleep(i * 100).then(() => {
                    DragAndDrop.createPreview(file);
                });
            }
        })();

        // Create a FormData object and append the selected files
        const formData = new FormData();
        formData.append("type", DragAndDrop.importType);
        formData.append("company", DragAndDrop.importForCompany);
        formData.append("week", App.pageProperties.data("week"));
        formData.append("month", App.pageProperties.data("month"));
        formData.append("year", App.pageProperties.data("year"));
        //formData.append("year", DragAndDrop.importForCompany);

        $.each(files, function (index, file) {
            formData.append("files[" + index + "]", file);
        });

        // Send the files to the server using AJAX
        $.ajax({
            url: App.ajaxUrl.switch,
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {

                if (!App.isJson(response)) {
                    console.warn("AJAX response not valid json");
                    return;
                }

                let jsonResponse = JSON.parse(response);

                let i = 0;

                if (jsonResponse.filePreview) {
                    (async function () {
                        for (let file of jsonResponse.filePreview) {
                            await DragAndDrop.sleep(300).then(() => {
                                let filePreview = $(DragAndDrop.fileList.children()[i]);

                                if (file.success) {
                                    DragAndDrop.setUploaded(filePreview);

                                    if ( !multiCompanyUser ) {
                                        setTimeout(() => {
                                            DragAndDrop.hide();
                                            DragAndDrop.clearFilePreviewList();
                                        }, 4000);
                                    }
                                } else {
                                    DragAndDrop.setError(filePreview, file.error);
                                }
                            });

                            i++;
                        }
                    })();
                }

                setTimeout(() => {
                    DragAndDrop.allowButton();

                    Forms.success(null, jsonResponse);

                    if (jsonResponse.success === true) {
                        Forms.el.trigger("change");
                    }
                }, 2000);
            }
        });
    },

    setAnimationBalls() {
        let hrElement;
        let counter = 30;
        let element = this.circleIndicator.find('.effect');

        let colorLength = DragAndDrop.animationCircleColors.length;
        let sizesLength = DragAndDrop.animationCircleSizes.length;

        if (element.children().length !== 0) {
            return;
        }

        for (let i = 0; i < counter; i++) {
            hrElement = document.createElement("HR");

            let posLeft = Math.random() * this.circleIndicator.width() - 10;

            posLeft = posLeft < 0 ? 5 : posLeft;

            hrElement.style.left = Math.floor(posLeft) + "px";
            hrElement.style.animationDuration = 0.8 + Math.random() * 0.3 + "s";
            hrElement.style.animationDelay = Math.random() * 5 + "s";

            $(hrElement)
                .addClass(DragAndDrop.animationCircleColors[Math.floor(Math.random() * colorLength)])
                .addClass(DragAndDrop.animationCircleSizes[Math.floor(Math.random() * sizesLength)]);

            element.append(hrElement);
        }
    },

    createPreview(file) {

        const fileExtension = file.name.split(".").pop().toLowerCase();
        let error = false;

        if (!DragAndDrop.allowedExtensions.includes(fileExtension)) {
            console.warn(file.name + " not supported. Filetype not found in: ", DragAndDrop.allowedExtensions);
            error = true;
        }

        let preview = $(DragAndDrop.previewTemplate).clone();

        preview.find('.name').text(file.name);
        preview.find('.filesize').text(DragAndDrop.byteConverter(file.size, 2));

        setTimeout(() => {
            preview.addClass('fadein');
        }, 200);

        if (error) {
            preview.addClass('error');
            preview.find(".status").html("Nepodporovaný súbor");
        }

        DragAndDrop.fileList.append(preview);
    },

    setUploaded(filePreview) {
        $(DragAndDrop.fileInput).val("");

        setTimeout(() => {
            filePreview.addClass('done');
            filePreview.find(".status").html("Spracovanie dokončené");
        }, 1600);
    },

    setError(filePreview, error) {
        setTimeout(() => {
            filePreview.addClass('error');
            filePreview.find(".status").html(error.text);

            if (error.textLong) {
                filePreview.find(".status").attr("title", App.removeTagsFromString(error.textLong)).addClass("highlighted");
            }
        }, 1600);
    },

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },

    byteConverter(bytes, decimals, only) {
        const K_UNIT = 1024;
        const SIZES = ["B", "KB", "MB", "GB", "TB", "PB"];

        if (bytes == 0) {
            return "0 Byte";
        }

        if (only === "MB") {
            return (bytes / (K_UNIT * K_UNIT)).toFixed(decimals) + " MB";
        }

        let i = Math.floor(Math.log(bytes) / Math.log(K_UNIT));
        let resp = parseFloat((bytes / Math.pow(K_UNIT, i)).toFixed(decimals)) + " " + SIZES[i];

        return resp;
    },

    containsFiles(event) {
        if (event.dataTransfer.types) {
            for (var i = 0; i < event.dataTransfer.types.length; i++) {
                if (event.dataTransfer.types[i] == "Files") {
                    return true;
                }
            }
        }

        return false;
    }
}
export default DragAndDrop;